// data/languages/copte/categories/animaux.ts

import { CategoryData } from '../../../../types/types';

export const animaux: CategoryData = {
    // Animaux sauvages
    'ⲙⲟⲩⲓ (moui)': {
        translation: 'Lion',
        translationEn: 'Lion',
        illustration: '🦁'
    },
    'ϫⲟⲩ (jou)': {
        translation: 'Éléphant',
        translationEn: 'Elephant',
        illustration: '🐘'
    },
    'ⲡⲁⲣⲇⲁⲗⲓⲥ (pardalis)': {
        translation: 'Panthère/Léopard',
        translationEn: 'Panther/Leopard',
        illustration: '🐆'
    },
    'ⲡⲓⲑⲏⲕⲟⲥ (pithêkos)': {
        translation: 'Singe',
        translationEn: 'Monkey',
        illustration: '🐒'
    },
    'ϭⲁⲃⲟⲩⲓ (chaboui)': {
        translation: 'Antilope / Gazelle',
        translationEn: 'Antelope / Gazelle',
        illustration: '🦌'
    },
    'ϩⲧⲱⲣ (htôr)': {
        translation: 'Mulet / Âne sauvage',
        translationEn: 'Mule / Wild donkey',
        illustration: '🐴'
    },
    'ⲉⲙⲟⲩ (emou - hippopotame)': {
        translation: 'Hippopotame',
        translationEn: 'Hippopotamus',
        illustration: '🦛'
    },
    // **NOTE** : La Girafe est un animal peu documenté en Copte ancien. Une traduction descriptive serait nécessaire.

    // Animaux domestiques
    'ⲉⲥⲟⲟⲩ (esoou)': {
        translation: 'Mouton',
        translationEn: 'Sheep',
        illustration: '🐑'
    },
    'ⲁⲗⲉⲕⲧⲱⲣ (alektôr)': {
        translation: 'Poule / Coq',
        translationEn: 'Hen / Rooster',
        illustration: '🐔'
    },
    'ⲟⲩϩⲟⲣ (ouhor)': {
        translation: 'Chien',
        translationEn: 'Dog',
        illustration: '🐕'
    },
    'ⲉⲙⲟⲩ (emou)': {
        translation: 'Chat',
        translationEn: 'Cat',
        illustration: '🐈'
    },
    'ⲙⲁⲥⲉ (mase)': {
        translation: 'Vache / Bétail',
        translationEn: 'Cow / Cattle',
        illustration: '🐄'
    },
    'ϩⲧⲟ (hto)': {
        translation: 'Cheval',
        translationEn: 'Horse',
        illustration: '🐎'
    },
    'ⲃⲁⲁⲙⲡⲉ (baampe)': {
        translation: 'Porc / Sanglier',
        translationEn: 'Pig / Boar',
        illustration: '🐖'
    },
    'ⲁⲥⲟⲟⲩ (asoou)': {
        translation: 'Chèvre',
        translationEn: 'Goat',
        illustration: '🐐' // AUDIO A VÉRIFIER
    },
    'ⲉⲓⲱ (eiô)': {
        translation: 'Âne',
        translationEn: 'Donkey',
        illustration: '🐴'
    },
    'ϭⲁⲙⲟⲩⲗ (chamoul)': {
        translation: 'Chameau',
        translationEn: 'Camel',
        illustration: '🐫'
    }
};

export default animaux;
